//
import Model from '@/models/Model'

//
export default class AMassiveEditOffer extends Model {
  static patch(data) {
    return this.$http.request({
      method: 'patch',
      url: process.env.VUE_APP_API_ROUTE.concat('/massive_edit_offer'),
      data,
    })
  }
  resource() {
    return 'massive_edit_offer'
  }
}